/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    PremiumLabel: {
        id: 'cep.components.sgSptRenewalPremium.PremiumLabel',
        defaultMessage: 'Total price:'
    },
    PremiumLabelWithChanges: {
        id: 'cep.components.sgSptRenewalPremium.PremiumLabelWithChanges',
        defaultMessage: 'New renewal price'
    },
    PreviousPremiumLabel: {
        id: 'cep.components.sgSptRenewalPremium.PreviousPremiumLabel',
        defaultMessage: 'Last year\'s premium: '
    },
    PreviousPremiumLabelWithChanges: {
        id: 'cep.components.sgSptRenewalPremium.PreviousPremiumLabelWithChanges',
        defaultMessage: 'Original renewal price: '
    },
    ShopAroundLessThanThreeLabel: {
        id: 'cep.components.sgSptRenewalPremium.ShopAroundLessThanThreeLabel',
        defaultMessage: 'Please review your level of cover to ensure it still meets your needs. You may be able to get the insurance cover you want at a better price if you shop around. Please remember to make sure the other cover is comparable to your Saga policy, which includes many great features and benefits.'
    },
    ComprehensiveCoverLabel: {
        id: 'cep.components.sgSptRenewalPremium.ComprehensiveCoverLabel',
        defaultMessage: 'At Saga we have 2 Comprehensive cover levels: Standard and Plus. If you\'d like to discuss the different options, please contact us via '
    },
    ComprehensiveCoverLabelAggs: {
        id: 'cep.components.sgSptRenewalPremium.ComprehensiveCoverLabelAggs',
        defaultMessage: 'In addition to our Saga Select product, we also offer two comprehensive cover levels: Standard and Plus.  If you\'d like to discuss the different options, please contact us via '
    },
    ComprehensiveCoverLabelWebChat: {
        id: 'cep.components.sgSptRenewalPremium.ComprehensiveCoverLabelWebChat',
        defaultMessage: 'webchat.'
    },
    ComprehensiveCoverLabelAlternatively: {
        id: 'cep.components.sgSptRenewalPremium.ComprehensiveCoverLabelAlternatively',
        defaultMessage: ' Alternatively, you can call us on {phoneNumber} and we will help you find the cover that is right for you.'
    },
    ClickingAcceptLabel: {
        id: 'cep.components.sgSptRenewalPremium.ClickingAcceptLabel',
        defaultMessage: '<span>By clicking <b>Renew now</b>, you confirm that you have read the above</span>'
    },
    ConfirmRenewalLabelFirst: {
        id: 'cep.components.sgSptRenewalPremium.ConfirmRenewalLabelFirst',
        defaultMessage: 'By proceeding with your renewal, you are agreeing that you have read all of the '
    },
    ConfirmRenewalLabelSecond: {
        id: 'cep.components.sgSptRenewalPremium.ConfirmRenewalLabelSecond',
        defaultMessage: ' and that your personal details, cover options and any declared pre-existing medical conditions are correct.'
    },
    ConfirmRenewalLabelDocsUnavailable: {
        id: 'cep.components.sgSptRenewalPremium.ConfirmRenewalLabelDocsUnavailable',
        defaultMessage: 'By proceeding with your renewal, you are agreeing that you have read all of the renewal documents and that your personal details, cover options and any declared pre-existing medical conditions are correct.'
    },
    RenewalDocumentLabel: {
        id: 'cep.components.sgSptRenewalPremium.RenewalDocumentLabel',
        defaultMessage: 'renewal documents'
    },
});
